import { defineComponent as _defineComponent } from 'vue';
import { useTrackingUtils } from '@scripts/composables/useTrackingUtils';
export default /*@__PURE__*/ _defineComponent({
    __name: 'GtmTracker',
    props: {
        allowTracking: { type: Boolean },
        postAudience: {},
        postCollections: {},
        postContentTypes: {},
        postType: {},
        postDatePublished: {},
        readWatchAuthor: {},
        readWatchSourcedInJapan: { type: [Boolean, null] },
        readWatchRelatedEvents: {}
    },
    setup(__props) {
        const { trackEvent } = useTrackingUtils();
        const props = __props;
        // Fire as early as possible during setup, before any mount lifecycle
        if (props.allowTracking) {
            trackEvent({
                event: 'page_view',
                post_content_pillar: props.postAudience,
                post_collections: props.postCollections,
                post_content_types: props.postContentTypes,
                post_type: props.postType,
                post_date_published: props.postDatePublished,
                read_watch_author: props.readWatchAuthor,
                read_watch_sourced_in_japan: props.readWatchSourcedInJapan,
                read_watch_related_events: props.readWatchRelatedEvents,
            });
        }
        return (_ctx, _cache) => {
            return null;
        };
    }
});
